import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=7b3a07f9&scoped=true"
import script from "./Carousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=7b3a07f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a07f9",
  null
  
)

export default component.exports